import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			meta: {
				breadcrumb: "Vint",
				title: "Toolkit für Demokratie und Transparenz bei Volt"
			},
			name: "home",
			component: HomeView
		}, {
			path: "/vorstand",
			name: "vorstand",
			meta: { title: "Vorstand" },
			component: () => import("../views/DemokratieView.vue")
		}, {
			path: "/city-leads",
			name: "city-leads",
			meta: { title: "City-Leads" },
			component: () => import("../views/CityLeadsView.vue")
		}, {
			path: "/stimmzettel",
			meta: { title: "Stimmzettel" },
			name: "stimmzettel",
			component: () => import("../views/stimmzettel/StimmzettelParent.vue"),
			children: [{
				path: "",
				meta: { titel: "Stimmzettel" },
				name: "stimmzettel",
				component: () => import("../views/stimmzettel/StimmzettelSetup.vue")
			}, {
				path: "abstimmungen",
				meta: { title: "Abstimmungen" },
				name: "stimmzettel_abstimmungen",
				component: () => import("../views/stimmzettel/AbstimmungenView.vue")
			}]
		}, {
			path: "/abschnitt-c-setup",
			meta: { title: "Abschnitt C Setup" },
			name: "abschnitt-c-setup",
			component: () => import("../views/abschnittc/AbschnittCSetupView.vue")
		}, {
			path: "/abschnitt-c/:code",
			meta: { title: "Abschnitt C" },
			name: "abschnitt-c",
			component: () => import("../views/abschnittc/AbschnittCParent.vue"),
			children: [
				{
					path: "zaehlkommission", meta: { title: "Zählkommission" }, name: "abschnitt-c_zk",
					/* ZK Views:
					   - Settings Editor
					   - Candidates Editor
					   - List Vote Input
					   - List Vote Count View
					   - Lot Input
					   - Acceptance Input
					   - Single Vote Input
					   - Export View
					 */
					children: [
						{
							path: "settings-editor", meta: { "title": "Einstellungen bearbeiten" },
							name: "abschnitt-c_zk_settings_editor",
							component: () => import("../views/abschnittc/zk/SettingsEditorView.vue")
						}, {
							path: "candidates-editor", meta: { "title": "Kandidaten bearbeiten" },
							name: "abschnitt-c_zk_candidates_editor",
							component: () => import("../views/abschnittc/zk/CandidatesEditorView.vue")
						}, {
							path: "list-vote-ballot", meta: { "title": "Stimmzettel für Listenwahl" },
							name: "abschnitt-c_zk_list_vote_input",
							component: () => import("../views/abschnittc/zk/ListVoteBallotView.vue")
						}, {
							path: "list-vote-count", meta: { "title": "Listenwahl Stimmzettel zählen" },
							name: "abschnitt-c_zk_list_vote_count",
							component: () => import("../views/abschnittc/zk/ListVoteCountView.vue")
						}, {
							path: "lot-input", meta: { "title": "Losentscheide" },
							name: "abschnitt-c_zk_lot_input",
							component: () => import("../views/abschnittc/zk/LotInputView.vue")
						}, {
							path: "acceptance-input", meta: { "title": "Wahlannahme" },
							name: "abschnitt-c_zk_acceptance_input",
							component: () => import("../views/abschnittc/zk/AcceptanceInputView.vue")
						}, {
							path: "single-vote-input", meta: { "title": "Einzelwahlen" },
							name: "abschnitt-c_zk_single_vote_input",
							component: () => import("../views/abschnittc/zk/SingleVoteInputView.vue")
						}, {
							path: "export-view", meta: { "title": "Export" },
							name: "abschnitt-c_zk_export_view",
							component: () => import("../views/abschnittc/zk/ExportView.vue")
						}
					]
				},
				{
					path: "versammlungsleitung", meta: { title: "Versammlungsleitung" }, name: "abschnitt-c_vl",
					/* VL Views:
					   - Settings Confirm
					   - Candidates Confirm
					   - List Result View
					   - Single Vote Result View
					   - Final View
					 */
					children: [
						{
							path: "settings-confirm", meta: { "title": "Einstellungen bestätigen" },
							name: "abschnitt-c_vl_settings_confirm",
							component: () => import("../views/abschnittc/vl/SettingsConfirmView.vue")
						}, {
							path: "candidates-confirm", meta: { "title": "Bewerber*innen bestätigen" },
							name: "abschnitt-c_vl_candidates_confirm",
							component: () => import("../views/abschnittc/vl/CandidatesConfirmView.vue")
						}, {
							path: "list-result", meta: { "title": "Vorläufige Listen" },
							name: "abschnitt-c_vl_list_result",
							component: () => import("../views/abschnittc/vl/ListResultView.vue")
						}, {
							path: "list-vote-overview", meta: { "title": "Listenwahl Übersicht" },
							name: "abschnitt-c_vl_list_vote_overview",
							component: () => import("../views/abschnittc/vl/ListVoteOverviewView.vue")
						}, {
							path: "single-vote-result", meta: { "title": "Einzelwahlergebnisse" },
							name: "abschnitt-c_vl_single_vote_result",
							component: () => import("../views/abschnittc/vl/SingleVoteResultView.vue")
						}, {
							path: "final", meta: { "title": "Endgültige Liste" },
							name: "abschnitt-c_vl_final",
							component: () => import("../views/abschnittc/vl/FinalView.vue")
						}
					]
				}
			]
		}, {
			path: "/karten",
			meta: { title: "Karten & Wahlkreise" },
			name: "karten",
			children: [
				{
					path: "",
					name: "karten",
					component: () => import("../views/karten/KartenView.vue")
				},
				{
					path: "wahlkreisbestimmung/liste",
					name: "karten_wahlkreisbestimmung_liste",
					meta: { title: "Wahlkreisbestimmung (Liste)" },
					component: () => import("../views/karten/WkListe.vue")
				}, {
					path: "wahlkreisbestimmung-einzeln",
					name: "karten_wahlkreisbestimmung_einzeln",
					meta: { title: "Wahlkreisbestimmung (Einzeln)" },
					component: () => import("../views/karten/WkEinzeln.vue")
				}
			]
		}, {
			path: "/wahlantritt",
			meta: { title: "Wahlantritt & Dokumente" },
			name: "wahlantritt",
			component: () => import("../views/WahlantrittView.vue")
		}
	]
});

export default router;
